<template>
  <dir v-resize="onResize" style="padding: 0; margin: 0">
    <div v-if="hasAlternative" style="border-bottom: 1px solid #eee; margin-bottom: 15px">
      <v-layout class="mb-2">
        <v-flex class="pl-3">
          {{ $t('Chatbot answers') }}
        </v-flex>
        <v-flex shrink class="text-xs-right"> </v-flex>
      </v-layout>
    </div>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <div>
          <template v-for="i in intentItems.length">
            <transition
              :key="`${i}_${timestamp}`"
              @before-enter="beforeEnter"
              @enter="enter"
              @after-enter="afterEnter"
              @before-leave="beforeLeave"
              @leave="leave"
              @after-leave="afterLeave"
            >
              <TemplateIntentGroupItem
                v-show="currentAlternative == i - 1"
                :key="`${i}_${timestamp}`"
                v-model="intentItems[i - 1]"
                class="intent-group-item"
                :is-welcome="isWelcome"
                :index-alternative="i"
                :intentname="intentname"
                :max-intent="maxIntent"
                :inactive-text-bubble="inactiveTextBubble"
              />
            </transition>
          </template>
        </div>
      </v-flex>
      <v-flex v-if="filterTextBubble.length > 0" xs12 sm6 class="px-2">
        <!-- <div
          v-for="index in filterTextBubble.length"
          :key="`custom_wording_${index + 1}`"
          class="mb-2"
        > -->
        <CustomWordingManageCard v-model="customWordingList" :is-live-chat="isLiveChat" />
        <!-- </div> -->
      </v-flex>
    </v-layout>
  </dir>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import Velocity from 'velocity-animate'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import TemplateIntentGroupItem from './TemplateIntentGroupItem.vue'
import CustomWordingManageCard from './CustomWordingManageCard.vue'

export default {
  components: {
    TemplateIntentGroupItem,
    CustomWordingManageCard
  },
  inject: ['$validator'],
  props: {
    value: {
      default: ''
    },
    hasAlternative: {
      default: true,
      type: Boolean
    },
    isWelcome: {
      dafault: false,
      type: Boolean
    },
    intentname: {
      default: ''
    },
    showMultipleChannel: {
      default: false
    },
    tab: {
      default: 'all'
    },
    maxIntent: {
      default: 10
    },
    hideSetting: {
      default: false
    },
    availableBubbles: {},
    sendType: {
      default: 'promotion',
      type: String
    },
    isLiveChat: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      addLimit: this.maxIntent,
      group: '',
      intentItems: [],
      showEmoji: false,
      typingTimer: null,
      currentIndex: null,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentAlternative: 0,
      productlist: [],
      showSetting: false,
      input: {
        showMultipleChannel: false,
        randomStatus: false
      },
      timestamp: moment().format('x'),
      maxRandomBarWidth: 0,
      customWordingList: {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomeMessage: 'welcomeMessage'
    }),
    bubbleCount: function () {
      var vm = this

      if (vm.intentItems[vm.currentAlternative]) {
        var count = 0
        vm.intentItems[vm.currentAlternative].map((bubble) => {
          if (bubble.type == 'welcome_message') {
            if (vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
              count += vm.welcomeMessage.messages[0].length
            } else {
              count++
            }
          } else {
            count++
          }
        })
        return count
      } else {
        return 0
      }
    },
    filterTextBubble() {
      const tempIntentItems = (this.intentItems && this.intentItems[0]) || []
      return tempIntentItems.length > 0
        ? tempIntentItems.filter((item) => item.type === 'text')
        : []
    },
    inactiveTextBubble() {
      return this.filterTextBubble.length > 0
    }
  },
  watch: {
    group: function () {
      this.$emit('input', this.group)
    },
    value: function () {
      this.handleInitIntent()
    },
    customWordingList: {
      handler() {
        this.handleTransformIntentItems()
      },
      deep: true
    }
  },
  created: function () {
    this.group = this.value
    this.intentItems = this.group ? this.group : []
  },

  mounted() {
    this.onResize()
  },

  methods: {
    handleInitIntent() {
      const vm = this
      try {
        const tempValue = vm.value

        if (tempValue) {
          const tempIntentItems = (tempValue && tempValue[0]) || []
          const findIntentText = tempIntentItems.find((item) => item.type === 'text')

          if (findIntentText && findIntentText.example) {
            const tempCustomWording = findIntentText.example.body_text[0]

            const customWording = {}
            tempCustomWording.forEach((word, index) => {
              const key = `custom_wording_${index + 1}`
              Object.assign(customWording, { [key]: word })
            })
            vm.customWordingList = customWording
          }

          vm.group = tempValue
          vm.intentItems = vm.group
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleTransformIntentItems() {
      const vm = this
      try {
        const tempIntentItems = (vm.intentItems && vm.intentItems[0]) || []

        if (tempIntentItems.length > 0) {
          const findIntentText = tempIntentItems.find((item) => item.type === 'text')

          if (Object.keys(vm.customWordingList).length > 0) {
            const arrCustomWording = Object.values(vm.customWordingList)

            Object.assign(findIntentText, {
              example: {
                body_text: [[...arrCustomWording]]
              }
            })
          } else {
            delete findIntentText['example']
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    onResize() {
      if (this.$refs.randomBar) {
        let randomBarWidth = this.$refs.randomBar.clientWidth
        let addRandomBtnWidth = 48
        this.maxRandomBarWidth = randomBarWidth - addRandomBtnWidth
      }
    },
    onDeleteAlternative(alternative) {
      if (this.intentItems.length > 1) {
        this.intentItems.splice(alternative - 1, 1)
      }
      this.timestamp = moment().format('x')
    },
    toggleRandomStatus() {
      this.$set(this.input, 'randomStatus', !this.input.randomStatus)
    },
    changeSetting() {
      this.$emit('changeSetting', this.input)
      this.showSetting = false
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      setTimeout(() => {
        el.style.height = '100%'
        setTimeout(() => {
          Velocity(el, { opacity: 1, translateY: '10px' }, { complete: done, duration: 500 })
        }, 100)
      }, 600)
    },
    afterEnter: function () {
      //
    },
    beforeLeave: function (el) {
      el.style.opacity = 1
      // el.style.maxHeight = 'none'
    },
    leave: function (el, done) {
      Velocity(el, { opacity: 0, translateY: '-10px' }, { complete: done, duration: 500 })
    },
    afterLeave: function () {
      // el.style.maxHeight = 0
    },
    getProducts: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      vm.productlist = []
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }
      api.getProducts(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.productlist = response.productlist
        callback()
      })
    },

    nextAlternative: async function () {
      var intent = cloneDeep(this.intentItems[this.currentAlternative])
      this.intentItems.push(intent)
      await this.$nextTick()
      this.currentAlternative = this.intentItems.length - 1
      this.updateIntent()
      this.timestamp = moment().format('x')
    },
    addAlternativeMessnage: function () {
      this.intentItems.push([])
      this.currentAlternative = this.intentItems.length - 1
      this.updateIntent()
    },
    deleteAlternativeMessage: function (index) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: 'Pattern' + (index + 1)
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.intentItems.splice(index, 1)
            vm.currentAlternative = index - 1
            vm.updateIntent()
          }
        })
    },
    addIntentPrefill: function (index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.intentItems[index][subindex].type === 'text') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      } else if (vm.intentItems[index][subindex].type == 'button') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      }
      vm.updateIntent()
    },
    addIntentItem: function (type, index) {
      if (this.bubbleCount >= this.addLimit) {
        return false
      }
      if (type == 'text') {
        this.intentItems[index].push({
          text: '',
          type: type
        })
      } else if (type == 'button') {
        this.intentItems[index].push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image') {
        this.intentItems[index].push({
          image_url: '',
          type: type
        })
      } else if (type == 'generic') {
        this.intentItems[index].push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'welcome_message') {
        this.intentItems[index].push({
          type: type
        })
      } else if (type == 'viewsummary') {
        if (this.productlist.length == 0) {
          return false
        }
        this.intentItems[index].push({
          type: 'text',
          text: '{viewsummary}'
        })
      }
      this.updateIntent()
    },
    onDelete: function (index, subindex) {
      this.intentItems[index].splice(subindex, 1)
      this.updateIntent()
    },

    onMove: function (index, subindex, direction) {
      var vm = this
      if (direction == 'up') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex - 1, 1)[0])
      } else if (direction == 'down') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex + 1, 1)[0])
      }
      this.updateIntent()
    },
    onTyping: function () {
      // clearTimeout(this.typingTimer);
      // this.typingTimer = setTimeout(this.updateIntent(), 1000)
      this.updateIntent()
    },
    updateIntent: function () {
      let vm = this
      vm.group = vm.intentItems
    },
    addNewButton: function (index, subindex, payload) {
      if (this.intentItems[index][subindex].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.intentItems[index][subindex].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        this.updateIntent()
      }
    },
    editButton: function (index, subindex, bindex, payload) {
      if (this.intentItems[index][subindex].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.intentItems[index][subindex].buttons, bindex, payload)
        this.updateIntent()
      }
    },
    deleteButton: function (index, subindex, bindex) {
      // if (this.intentItems.length >= 1) {
      //     return false
      // }
      this.intentItems[index][subindex].buttons.splice(bindex, 1)
      this.updateIntent()
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-group-item {
  transition: height ease 2s;
  -webkit-transition: height ease 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/TemplateIntentGroup.vue